import { BetrokkenTrein, usePatchBusEvacuatieStatus } from "@/entities/betrokken-treinen";
import { ConfirmDialog } from "@/shared/components";

type BusEvacuatieIntrekkenProps = {
    dossierId: string;
    trein: BetrokkenTrein;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export function BusEvacuatieIntrekken({ dossierId, trein, open, onOpenChange }: BusEvacuatieIntrekkenProps) {
    const mutation = usePatchBusEvacuatieStatus();

    const handleConfirm = () => {
        mutation.mutate({ dossierId, treinId: trein.id, status: "AnnuleringAangevraagd" }, { onSuccess: () => onOpenChange(false) });
    };

    return (
        <ConfirmDialog
            title={`Intrekken evacuatiebus ${BetrokkenTrein.formatTrainLabel(trein)}`}
            isOpen={open}
            onCancel={() => {
                onOpenChange(false);
                mutation.reset();
            }}
            onConfirm={handleConfirm}
            confirmLabel="Busevacuatie intrekken"
            isPending={mutation.isPending}
            destructive
            error={mutation.error}
        >
            Weet je zeker dat je de evacuatiebus van {BetrokkenTrein.formatTrainLabel(trein)} wil intrekken?
        </ConfirmDialog>
    );
}
